import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    background: linear-gradient(135deg, var(--sl-color-primary-50) 0%, var(--sl-color-primary-100) 100%);
    display: flex;
    padding: 1rem;
  }

  .signup-container {
    width: 100%;
    margin: 0 auto;
    
  }
  .signup-card {
    background: white;
    border-radius: var(--sl-border-radius-large);
    box-shadow: var(--sl-shadow-x-large);
    padding: 15px;
    margin: 0 auto;
    max-width: 50%;
    border: 1px solid var(--sl-color-neutral-200);
  }

  .signup-header {
    text-align: center;
    margin-bottom: 2rem;
  }

  .signup-header sl-icon {
    color: var(--sl-color-primary-600);
    margin-bottom: 1rem;
  }

  .signup-header h2 {
    margin: 0 0 0.5rem 0;
    color: var(--sl-color-neutral-900);
    font-size: 1.75rem;
    font-weight: 600;
  }

  .signup-header p {
    margin: 0;
    color: var(--sl-color-neutral-600);
    font-size: 0.875rem;
  }

  .signup-form {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .form-section{
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  .form-section-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--sl-color-neutral-800);
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid var(--sl-color-primary-100);
  }

  .form-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    
    gap: 30px;
    
  }

  .form-row.single {
    grid-template-columns: 1fr;
  }

  .form-group {

    width: 100%;
  }

  .form-group.full-width {
    grid-column: 1 / -1;
  }

  .form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
    color: var(--sl-color-neutral-700);
    font-size: 0.875rem;
  }

  

  .form-group sl-textarea {
    resize: vertical;
    min-height: 80px;
  }

  .form-actions {
    align-self: flex-end;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: space-between;
  }

  .signup-button {
    flex: 1;
    height: 3rem;
    font-weight: 600;

  }

  .back-button {
    height: 3rem;
    font-weight: 600;
  }

  .signup-footer {
    border-top: 1px solid var(--sl-color-neutral-200);
    padding-top: 1.5rem;
    text-align: center;
  }

  .signup-footer p {
    margin: 0 0 1rem 0;
    color: var(--sl-color-neutral-700);
    font-size: 0.875rem;
    font-weight: 500;
  }

  .error-message {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: var(--sl-color-danger-50);
    color: var(--sl-color-danger-700);
    padding: 0.75rem;
    border-radius: var(--sl-border-radius-medium);
    border: 1px solid var(--sl-color-danger-200);
    margin-bottom: 1rem;
    font-size: 0.875rem;
  }

  .error-message sl-icon {
    color: var(--sl-color-danger-600);
  }

  .success-message {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: var(--sl-color-success-50);
    color: var(--sl-color-success-700);
    padding: 0.75rem;
    border-radius: var(--sl-border-radius-medium);
    border: 1px solid var(--sl-color-success-200);
    margin-bottom: 1rem;
    font-size: 0.875rem;
  }

  .success-message sl-icon {
    color: var(--sl-color-success-600);
  }
@media (max-width: 768px) {
  .form-row {
    gap: 15px;
    flex-wrap: wrap;
  }
  .form-section{
    gap: 15px;
  }
}
`;
